module.exports = __webpack_public_path__ + "media/images/client-12-c91a6be155092c85576b48a3e8eccffd.png";